export const States = {
  us: [
    {
      name: 'Alabama',
      abbr: 'AL',
    },
    {
      name: 'Alaska',
      abbr: 'AK',
    },
    {
      name: 'Arizona',
      abbr: 'AZ',
    },
    {
      name: 'Arkansas',
      abbr: 'AR',
    },
    {
      name: 'California',
      abbr: 'CA',
    },
    {
      name: 'Colorado',
      abbr: 'CO',
    },
    {
      name: 'Connecticut',
      abbr: 'CT',
    },
    {
      name: 'Delaware',
      abbr: 'DE',
    },
    {
      name: 'Florida',
      abbr: 'FL',
    },
    {
      name: 'Georgia',
      abbr: 'GA',
    },
    {
      name: 'Hawaii',
      abbr: 'HI',
    },
    {
      name: 'Idaho',
      abbr: 'ID',
    },
    {
      name: 'Illinois',
      abbr: 'IL',
    },
    {
      name: 'Indiana',
      abbr: 'IN',
    },
    {
      name: 'Iowa',
      abbr: 'IA',
    },
    {
      name: 'Kansas',
      abbr: 'KS',
    },
    {
      name: 'Kentucky',
      abbr: 'KY',
    },
    {
      name: 'Louisiana',
      abbr: 'LA',
    },
    {
      name: 'Maine',
      abbr: 'ME',
    },
    {
      name: 'Maryland',
      abbr: 'MD',
    },
    {
      name: 'Massachusetts',
      abbr: 'MA',
    },
    {
      name: 'Michigan',
      abbr: 'MI',
    },
    {
      name: 'Minnesota',
      abbr: 'MN',
    },
    {
      name: 'Mississippi',
      abbr: 'MS',
    },
    {
      name: 'Missouri',
      abbr: 'MO',
    },
    {
      name: 'Montana',
      abbr: 'MT',
    },
    {
      name: 'Nebraska',
      abbr: 'NE',
    },
    {
      name: 'Nevada',
      abbr: 'NV',
    },
    {
      name: 'New Hampshire',
      abbr: 'NH',
    },
    {
      name: 'New Jersey',
      abbr: 'NJ',
    },
    {
      name: 'New Mexico',
      abbr: 'NM',
    },
    {
      name: 'New York',
      abbr: 'NY',
    },
    {
      name: 'North Carolina',
      abbr: 'NC',
    },
    {
      name: 'North Dakota',
      abbr: 'ND',
    },
    {
      name: 'Ohio',
      abbr: 'OH',
    },
    {
      name: 'Oklahoma',
      abbr: 'OK',
    },
    {
      name: 'Oregon',
      abbr: 'OR',
    },
    {
      name: 'Pennsylvania',
      abbr: 'PA',
    },
    {
      name: 'Rhode Island',
      abbr: 'RI',
    },
    {
      name: 'South Carolina',
      abbr: 'SC',
    },
    {
      name: 'South Dakota',
      abbr: 'SD',
    },
    {
      name: 'Tennessee',
      abbr: 'TN',
    },
    {
      name: 'Texas',
      abbr: 'TX',
    },
    {
      name: 'Utah',
      abbr: 'UT',
    },
    {
      name: 'Vermont',
      abbr: 'VT',
    },
    {
      name: 'Virginia',
      abbr: 'VA',
    },
    {
      name: 'Washington',
      abbr: 'WA',
    },
    {
      name: 'West Virginia',
      abbr: 'WV',
    },
    {
      name: 'Wisconsin',
      abbr: 'WI',
    },
    {
      name: 'Wyoming',
      abbr: 'WY',
    },
  ],
  canada: [
    {
      name: 'Alberta',
      abbr: 'AB',
    },
    {
      name: 'British Columbia',
      abbr: 'BC',
    },
    {
      name: 'Manitoba',
      abbr: 'MB',
    },
    {
      name: 'New Brunswick',
      abbr: 'NB',
    },
    {
      name: 'Newfoundland and Labrador',
      abbr: 'NL',
    },
    {
      name: 'Northwest Territories',
      abbr: 'NT',
    },
    {
      name: 'Nova Scotia',
      abbr: 'NS',
    },
    {
      name: 'Nunavut',
      abbr: 'NU',
    },
    {
      name: 'Ontario',
      abbr: 'ON',
    },
    {
      name: 'Prince Edward Isle',
      abbr: 'PE',
    },
    {
      name: 'Quebec',
      abbr: 'QC',
    },
    {
      name: 'Saskatchewan',
      abbr: 'SK',
    },
    {
      name: 'Yukon',
      abbr: 'YT',
    },
  ],
}
const Provinces = [...States.canada]
const STATES = [...States.us, ...States.canada]

/**
 * Gets a two-letter state code by name.
 * @returns UPPERCASE state abbr., if found.
 * @param state State name to get abbreviation for
 */
function stateAbbrByName(state: string) {
  if (!state) return undefined
  state = state.toLowerCase()
  const matchingState = STATES.find((obj) => obj.name.toLowerCase() === state)
  if (matchingState) return matchingState.abbr
  return undefined
}

/**
 * Gets a state name by two-letter abbreviation.
 * @returns Title Case state name, if found.
 * @param state State abbreviation to get name for
 */
function stateNameByAbbr(abbr: string) {
  if (!abbr) return undefined
  abbr = abbr.toLowerCase()
  const matchingState = STATES.find((obj) => obj.abbr.toLowerCase() === abbr)
  if (matchingState) return matchingState.name
  return undefined
}

const abbrIsRapidCash = (abbr = '') =>
  ['wa', 'or', 'nv'].includes(abbr.toLowerCase())
const isRapidCash = (state = '') =>
  ['washington', 'oregon', 'nevada'].includes(state.toLowerCase())

const toTitleCase = function (sentence: string) {
  const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
  const wordSeparators = /([ :–—-])/

  return sentence
    .split(wordSeparators)
    .map(function (current, index, array) {
      if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ':' &&
        array[index + 1] !== ':' &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== '-' ||
          (array[index - 1] === '-' && array[index + 1] === '-'))
      ) {
        return current.toLowerCase()
      }

      /* Ignore intentional capitalization */
      if (current.substr(1).search(/[A-Z]|\../) > -1) {
        return current
      }

      /* Ignore URLs */
      if (array[index + 1] === ':' && array[index + 2] !== '') {
        return current
      }

      /* Capitalize the first letter */
      return current.replace(alphanumericPattern, function (match) {
        return match.toUpperCase()
      })
    })
    .join('')
}

export {
  STATES,
  Provinces,
  stateAbbrByName,
  stateNameByAbbr,
  abbrIsRapidCash,
  isRapidCash,
  toTitleCase,
}
